import { render } from "./SortTableComponent.vue?vue&type=template&id=d6522fb0&scoped=true"
import script from "./SortTableComponent.vue?vue&type=script&lang=js"
export * from "./SortTableComponent.vue?vue&type=script&lang=js"

import "./SortTableComponent.vue?vue&type=style&index=0&id=d6522fb0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6522fb0"]])

export default __exports__